import {GetPaginationGuestDto} from '../features/guests/model'
import {paginationGuestsService} from '../features/guests/services'
import {getMasterModuleService} from '../features/modules/services'

export const useGuests = () => {
  const getGuests = async (filter: GetPaginationGuestDto) => {
    try {
      const {data: response} = await paginationGuestsService(filter)
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        return mappedGuests
      }
      return []
    } catch (error) {
      return []
    }
  }

  const getTypeGuest = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoHuesped',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getTypeStayGuest = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoEstadiaHuesped',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  return {
    getTypeStayGuest,
    getTypeGuest,
    getGuests,
  }
}
